import useAsyncData from "../../../hooks/use-async-data";
import DriverDetailsParams from "./driver-details-params";
import DriverDetails from "./driver-details";
import driverService from "../driver.service";

const useDriverDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<DriverDetails | null>(null);

  const load = async (params: DriverDetailsParams, signal: AbortSignal) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const driverDetails = await driverService.getDetails(params, signal);

      setData(driverDetails);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDriverDetails;
